import { AccountCircleRounded, ListAltOutlined } from "@mui/icons-material";
import { Avatar, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

import Colors from "../../../../../styles/Colors";

export const ProviderTableRow = ({ data, onDetailClick }) => {
  const handleClick = (data) => {
    const id = data.pk || data.id;
    onDetailClick(id);
  };
  return (
    <TableRow data-testid="provider-row">
      <TableCell className="sticky left-0 gap-1 bg-white shadow-[-1px_3px_6px_lightgray]">
        <Tooltip title="View Provider Detail">
          <IconButton className="mr-1 hover:bg-gray-300" onClick={() => handleClick(data)}>
            {data?.photo ? (
              <Avatar src={data?.photo} alt={data?.name} className="h-[50px] w-[50px]" />
            ) : (
              <AccountCircleRounded sx={{ fontSize: 55, color: Colors.gray[400] }} />
            )}
          </IconButton>
        </Tooltip>
        {data?.name || "-"}
      </TableCell>
      <TableCell align="center" className="whitespace-nowrap">
        {data?.address?.formatted || data?.address?.raw || "-"}
      </TableCell>
      <TableCell align="center" className="whitespace-nowrap">
        {data?.rating || "-"}
      </TableCell>
      <TableCell align="center" className="whitespace-nowrap">
        {data?.inNetwork ? "In-Network" : "Out of Network"}
      </TableCell>
      <TableCell align="center" className="whitespace-nowrap">
        <div className="mx-2 mt-1 flex flex-col gap-1">
          {data?.providerTypes?.map((type) => <div key={type.id}>{type?.name}</div>) || []}
        </div>
      </TableCell>
      <TableCell
        align="center"
        className="sticky right-0 whitespace-nowrap bg-white shadow-[2px_3px_6px_lightgray]"
      >
        <Tooltip title="View Provider Detail" placement="right">
          <IconButton
            data-testid="view-detail"
            onClick={() => handleClick(data)}
            className="my-auto aspect-square h-fit flex-1"
          >
            <ListAltOutlined className="text-purple-600" />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

ProviderTableRow.propTypes = {
  data: PropTypes.object,
  onDetailClick: PropTypes.func,
};
